/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import React, { FC } from "react";

export enum FIELD_NOTE_ALIGN {
	LEFT = "left",
	CENTER = "center",
	RIGHT = "right"
}

export interface IFieldNoteProps {
	color?: string;
	padded?: boolean;
	italic?: boolean;
	bold?: boolean;
	align?: FIELD_NOTE_ALIGN;
	withBorder?: boolean;
	className?: string;
}

export const FieldNote: FC<IFieldNoteProps> = ({
	children,
	color,
	padded,
	italic,
	bold,
	align,
	withBorder,
	className
}) => {
	const baseClass = BEM("edt-field-note", null, {
		padded: padded,
		italic: italic,
		bold: bold,
		align: align,
		"with-border": withBorder
	});

	if (color) {
		baseClass.mod("color-" + color);
	}

	if (className) {
		baseClass.add(className);
	}

	return <span className={baseClass.toClassName()}>{children}</span>;
};
